import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { CompanyHomeTheme } from './themes/types';
import DataGrid from '@plasma/ui.display.data-grid';

const styled = baseStyled as ThemedStyledInterface<CompanyHomeTheme>;
const css = baseCss as ThemedCssFunction<CompanyHomeTheme>;

export const CompanyHome = styled.div`
  width: 100%;
  height: 100%;
`;


// export const PlantLayoutContainer = styled.div `
//   height: 90vh;
// `;
